import { useState, useCallback } from "react";
import VuiAlert from "components/VuiAlert";
import VuiBox from "components/VuiBox";

export function useAppAlert(timeoutMs = 5000) {
  const [alert, setAlert] = useState({ show: false, message: "", color: "info" });

  const showAlert = useCallback(
    (message, color = "info") => {
      setAlert({ show: true, message, color });
      setTimeout(() => setAlert({ show: false, message: "", color: "info" }), timeoutMs);
    },
    [timeoutMs]
  );

  const AlertBanner = () =>
    alert.show ? (
      <VuiBox mb={2}>
        <VuiAlert color={alert.color} dismissible>
          {alert.message}
        </VuiAlert>
      </VuiBox>
    ) : null;

  return { showAlert, AlertBanner };
}
